import ThemeStyles from './ThemeStyles'

export const calendarOptions = {
  locales: {
    'es-ES': {
      firstDayOfWeek: 2
    }
  },
  screens: {
    xs: '576px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
    xl: '1440px'
  },
  theme: ThemeStyles
}
